var Model = require("../types/Model.js");
var window = require("global");
var location = window.location;

/**
 * This model checks for changes in the version of the local content on Rackspace
 * @type {Model}
 */
module.exports = Model({
	name: "refresher",
	listeners: listeners,
	triggers: triggers,
	_destroying: false,
	_initialized: false,
	beginDestroy: beginDestroy,
});

function triggers(){
	return {
		"refresh": handle_refresh
	};
}

function listeners() {
	return {
		"mqtt:$/refresh": handle_refresh,
		"bluetooth:destroyed": handle_destroyed,
		"bluetooth:updated": handle_bluetooth_update
	};
}

function handle_refresh() {
	if (this._initialized)
		this.beginDestroy();
	else
		location.reload();

}

function handle_bluetooth_update(data) {
	this._initialized = data.initialized;
}

function beginDestroy() {
	this._destroying = true;
	this.emit("bluetooth:trigger:destroy");
}

function handle_destroyed() {
	if (!this._destroying) return;
	location.reload();
}
